// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsAssortmentTable-AsrtTableSettings-sections-AsrtTableDictSection-AsrtTableDictSection-module__box--YpZ5K {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.src-businessServices-services-bsAssortmentTable-AsrtTableSettings-sections-AsrtTableDictSection-AsrtTableDictSection-module__title--DhVC8 {
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsAssortmentTable/AsrtTableSettings/sections/AsrtTableDictSection/AsrtTableDictSection.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AACA;EACE,gBAAA;AACF","sourcesContent":[".box {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n.title {\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsAssortmentTable-AsrtTableSettings-sections-AsrtTableDictSection-AsrtTableDictSection-module__box--YpZ5K`,
	"title": `src-businessServices-services-bsAssortmentTable-AsrtTableSettings-sections-AsrtTableDictSection-AsrtTableDictSection-module__title--DhVC8`
};
export default ___CSS_LOADER_EXPORT___;
